import {
    graphXAxisLabelFontSize,
    groupBarChartWidth,
} from 'components/organism/GrowthAnalysis/BrandValueChartContainer/BrandValueChartContainer';
import { salesGraphWidth } from 'components/organism/GrowthAnalysis/SalesChartContainer/SalesChartContainer';
import { salesTileKeyType } from 'components/pages/GrowthAnalysis';
import { colorConstants } from 'config/colorConstants';
import { renderTitle, renderTitleExpandDataHeader } from './getSalesAttributionColumns';
import { formatNumWithKMBAlt } from './helperMethods';

//const tableLabelFontSize = calculateFontSize(window.innerWidth, 11);

export const getGrowthAnalysisColumns = (
    data: any,
    volTile: any,
    from: salesTileKeyType = 'sales',
    expandedItem: any,
    drillDownSelectedData: any,
    commonConfig: any,
    expandedDataHeader?: any,
    showTotal: boolean = true,
) => {
    const result: any = [];
    Object.keys(data[0])?.map((key, idx) => {
        const temp = {
            title:
                key === 'type'
                    ? ''
                    : !expandedDataHeader
                    ? renderTitle(key, undefined, undefined, 'text-purpleFont !font-bold', graphXAxisLabelFontSize)
                    : renderTitleExpandDataHeader(
                          key,
                          undefined,
                          undefined,
                          'text-purpleFont !font-bold',
                          graphXAxisLabelFontSize,
                      ),
            dataIndex: key,
            width:
                key === 'type'
                    ? Math.max(salesGraphWidth, 140)
                    : from === 'sales' || from === 'depletion'
                    ? salesGraphWidth
                    : groupBarChartWidth,
            key: key,
            align: idx === 0 ? 'left' : 'center',
            fixed: idx === 0 || (showTotal && idx === 1) ? 'left' : false,
            onCell: (record: any, rowIndex: number) => {
                if (
                    ((from === 'sales' || from === 'depletion') &&
                        expandedItem &&
                        'attributeExId' in expandedItem &&
                        expandedItem['attributeExId'] === key?.trim()) ||
                    ((from === 'sales' || from === 'depletion') &&
                        drillDownSelectedData &&
                        'attributeExId' in drillDownSelectedData &&
                        drillDownSelectedData['attributeExId'] === key?.trim())
                ) {
                    return {
                        style: {
                            border: `1px solid ${colorConstants.borderGreyAlt}`,
                            background: colorConstants.lightPurple,
                        },
                    };
                }
            },
            // sorter:
            //     idx === 0
            //         ? false
            //         : (a: any, b: any, c: any, d: any) => {
            //               return a[key] - b[key];
            //           },
            render: (columnData: any, rowData: any, index: number) => {
                return (
                    <div
                        // style={{
                        //     ...categoryImpactedCommonStyles,
                        // }}
                        style={{ fontSize: graphXAxisLabelFontSize }}
                    >
                        {key === 'type' && typeof columnData === 'string' && !columnData.startsWith('% Change')
                            ? formatLabel(columnData, volTile, from)
                            : formatColumnData(columnData, volTile, commonConfig)}
                    </div>
                );
            },
        };
        result.push(temp);
    });
    return result;
};

function formatLabel(columnData: any, volTile: any, from: salesTileKeyType = 'sales') {
    return columnData;
    if (from === 'sales') {
        return columnData;
    }
    //for incremental and promo
    if (typeof columnData === 'string') {
        const arrayConverted = columnData.split(' ');
        const updatedString = arrayConverted[0] + ' ' + volTile.label + ' ' + arrayConverted.slice(1).join(' ');
        return updatedString;
    }
}

function formatColumnData(columnData: any, volTile: any, commonConfig: any) {
    if (Array.isArray(columnData)) {
        const decimalForPercentage = commonConfig?.decimalForPercentage ?? 2;
        const decimalForNonPercentage = commonConfig?.decimalForNonPercentage ?? 2;
        const index = 0;
        const pre = columnData[index].unit === '%' ? '' : columnData[index].unit;
        const post = columnData[index].unit === '%' ? columnData[index].unit : '';
        // const index = volTile.key === 'vol' ? 0 : 1;
        return (
            pre +
            formatNumWithKMBAlt(
                columnData[index].data,
                post === '%' ? decimalForPercentage : decimalForNonPercentage,
                post === '%' ? undefined : decimalForNonPercentage,
            ) +
            post
        );
    }

    return columnData;
}
